export const TABLE_UPDATE = "CATEGORIES/TABLE_UPDATE";
export const FETCH_SUCCESS = "CATEGORIES/FETCH_SUCCESS";

const types = {
    DESTROY_FAILED: "CATEGORIES/DESTROY_FAILED",
    DESTROY_REQUEST: "CATEGORIES/DESTROY_REQUEST",
    DESTROY_SUCCESS: "CATEGORIES/DESTROY_SUCCESS",

    FETCH_FAILED: "CATEGORIES/FETCH_FAILED",
    FETCH_REQUEST: "CATEGORIES/FETCH_REQUEST",
    FETCH_SUCCESS,

    FETCH_ALL_FAILED: "CATEGORIES/FETCH_ALL_FAILED",
    FETCH_ALL_REQUEST: "CATEGORIES/FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS: "CATEGORIES/FETCH_ALL_SUCCESS",

    GET_FAILED: "CATEGORIES/GET_FAILED",
    GET_REQUEST: "CATEGORIES/GET_REQUEST",
    GET_SUCCESS: "CATEGORIES/GET_SUCCESS",

    PATCH_FAILED: "CATEGORIES/PATCH_FAILED",
    PATCH_REQUEST: "CATEGORIES/PATCH_REQUEST",
    PATCH_SUCCESS: "CATEGORIES/PATCH_SUCCESS",
    
    STORE_FAILED: "CATEGORIES/STORE_FAILED",
    STORE_REQUEST: "CATEGORIES/STORE_REQUEST",
    STORE_SUCCESS: "CATEGORIES/STORE_SUCCESS",

    UPDATE_FAILED: "CATEGORIES/UPDATE_FAILED",
    UPDATE_REQUEST: "CATEGORIES/UPDATE_REQUEST",
    UPDATE_SUCCESS: "CATEGORIES/UPDATE_SUCCESS",
    TABLE_UPDATE,
};

export default types;
